import { apiClient as api } from './api';

export interface DashboardSummary {
  totalServers: number;
  onlineServers: number;
  offlineServers: number;
  totalApplications: number;
  healthyApplications: number;
  unhealthyApplications: number;
  totalAlerts: number;
  activeAlerts: number;
  unresolvedAlerts: number;
  unresolvedEStatementAlerts: number;
  unresolvedNonEStatementAlerts: number;
}

export interface ServerDashboard {
  serverId: string;
  serverName: string;
  tenantId: string;
  tenantName: string;
  status: 'healthy' | 'warning' | 'critical' | 'unknown';
  reason?: string;
  reasonDetails?: string;
  agentIsOnline: boolean;
  latestCpuUsage?: number;
  latestRamUsagePercent?: number;
  latestRamUsage?: number;
  latestRamTotal?: number;
  latestDiskUsage?: string;
  lastMetricTime?: string;
  totalApplications: number;
  healthyApplications: number;
  warningApplications: number;
  criticalApplications: number;
  activeAlerts: number;
  unresolvedAlerts: number;
  totalAgents: number;
}

export interface ServerSummary {
  id: string;
  name: string;
  status: 'healthy' | 'warning' | 'critical' | 'unknown';
  reason?: string;
  reasonDetails?: string;
  agentIsOnline: boolean;
  cpuUsage?: number;
  ramUsagePercent?: number;
  lastMetricTime?: string;
}

export interface TenantDashboard {
  tenantId: string;
  tenantName: string;
  totalServers: number;
  healthyServers: number;
  warningServers: number;
  criticalServers: number;
  totalApplications: number;
  healthyApplications: number;
  warningApplications: number;
  criticalApplications: number;
  activeAlerts: number;
  unresolvedAlerts: number;
  totalAgents: number;
  servers: ServerSummary[];
  applications: any[];
}

export const dashboardService = {
  /**
   * Dashboard özet verilerini getir
   */
  async getSummary(params?: {
    tenantIds?: string[];
    serverIds?: string[];
  }): Promise<DashboardSummary> {
    const queryParams = new URLSearchParams();
    
    if (params?.tenantIds && params.tenantIds.length > 0) {
      params.tenantIds.forEach(id => queryParams.append('tenantIds', id));
    }
    if (params?.serverIds && params.serverIds.length > 0) {
      params.serverIds.forEach(id => queryParams.append('serverIds', id));
    }

    const queryString = queryParams.toString();
    const url = `/dashboard/summary${queryString ? `?${queryString}` : ''}`;
    const response = await api.get<DashboardSummary>(url);
    return response.data;
  },

  /**
   * Server dashboard verilerini getir (status dahil)
   */
  async getServerDashboard(serverId: string): Promise<ServerDashboard> {
    const response = await api.get<ServerDashboard>(`/dashboard/server/${serverId}`);
    return response.data;
  },

  /**
   * Tenant dashboard verilerini getir (server durumları dahil)
   */
  async getTenantDashboard(tenantId: string): Promise<TenantDashboard> {
    const response = await api.get<TenantDashboard>(`/dashboard/tenant/${tenantId}`);
    return response.data;
  },
};

